// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/icons/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/icons/arrow-up.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=Outfit:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(15 82 186 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(15 82 186 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-4 {
  left: 1rem;
  right: 1rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-4 {
  bottom: -1rem;
}
.-bottom-5 {
  bottom: -1.25rem;
}
.-left-\\[31px\\] {
  left: -31px;
}
.-right-3 {
  right: -0.75rem;
}
.-right-4 {
  right: -1rem;
}
.-right-\\[300px\\] {
  right: -300px;
}
.-top-3 {
  top: -0.75rem;
}
.-top-\\[300px\\] {
  top: -300px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-\\[-20\\%\\] {
  bottom: -20%;
}
.bottom-\\[-200px\\] {
  bottom: -200px;
}
.bottom-\\[-4px\\] {
  bottom: -4px;
}
.bottom-\\[0\\%\\] {
  bottom: 0%;
}
.bottom-\\[40px\\] {
  bottom: 40px;
}
.bottom-\\[44px\\] {
  bottom: 44px;
}
.bottom-\\[84px\\] {
  bottom: 84px;
}
.bottom-\\[8px\\] {
  bottom: 8px;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/3 {
  left: 33.333333%;
}
.left-10 {
  left: 2.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-3\\.5 {
  left: 0.875rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[-10\\%\\] {
  left: -10%;
}
.left-\\[-200px\\] {
  left: -200px;
}
.left-\\[20\\%\\] {
  left: 20%;
}
.right-0 {
  right: 0px;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[-10\\%\\] {
  right: -10%;
}
.right-\\[-200px\\] {
  right: -200px;
}
.right-\\[-5\\%\\] {
  right: -5%;
}
.right-\\[10\\%\\] {
  right: 10%;
}
.right-\\[8px\\] {
  right: 8px;
}
.right-auto {
  right: auto;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/3 {
  top: 33.333333%;
}
.top-10 {
  top: 2.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-20 {
  top: 5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-\\[-10\\%\\] {
  top: -10%;
}
.top-\\[-200px\\] {
  top: -200px;
}
.top-\\[100\\%\\] {
  top: 100%;
}
.top-\\[11px\\] {
  top: 11px;
}
.top-\\[20\\%\\] {
  top: 20%;
}
.top-\\[80px\\] {
  top: 80px;
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100000\\] {
  z-index: 100000;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[1001\\] {
  z-index: 1001;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[150\\] {
  z-index: 150;
}
.z-\\[2000\\] {
  z-index: 2000;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[33\\] {
  z-index: 33;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[998\\] {
  z-index: 998;
}
.z-\\[999999\\] {
  z-index: 999999;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-10 {
  grid-column: span 10 / span 10;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.col-span-full {
  grid-column: 1 / -1;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-10 {
  margin-bottom: -2.5rem;
}
.-mb-6 {
  margin-bottom: -1.5rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-mr-10 {
  margin-right: -2.5rem;
}
.-mr-20 {
  margin-right: -5rem;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.-mt-20 {
  margin-top: -5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-24 {
  margin-bottom: 6rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[-10px\\] {
  margin-bottom: -10px;
}
.mb-auto {
  margin-bottom: auto;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-3\\.5 {
  margin-left: 0.875rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[3\\/4\\] {
  aspect-ratio: 3/4;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[11\\.5px\\] {
  height: 11.5px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30\\%\\] {
  height: 30%;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[37px\\] {
  height: 37px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[40\\%\\] {
  height: 40%;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[46px\\] {
  height: 46px;
}
.h-\\[50\\%\\] {
  height: 50%;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[57px\\] {
  height: 57px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[800px\\] {
  height: 800px;
}
.h-\\[82px\\] {
  height: 82px;
}
.h-\\[auto\\] {
  height: auto;
}
.h-\\[calc\\(100\\%_-_110px\\)\\] {
  height: calc(100% - 110px);
}
.h-\\[calc\\(100vh_-220px\\)\\] {
  height: calc(100vh - 220px);
}
.h-\\[calc\\(100vh_-_187px\\)\\] {
  height: calc(100vh - 187px);
}
.h-\\[calc\\(100vh_-_254px\\)\\] {
  height: calc(100vh - 254px);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-52 {
  max-height: 13rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-\\[100px\\] {
  max-height: 100px;
}
.max-h-\\[140px\\] {
  max-height: 140px;
}
.max-h-\\[150px\\] {
  max-height: 150px;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[220px\\] {
  max-height: 220px;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[260px\\] {
  max-height: 260px;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[320px\\] {
  max-height: 320px;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[450px\\] {
  max-height: 450px;
}
.max-h-\\[56px\\] {
  max-height: 56px;
}
.max-h-\\[72vh\\] {
  max-height: 72vh;
}
.max-h-\\[75vh\\] {
  max-height: 75vh;
}
.max-h-\\[78vh\\] {
  max-height: 78vh;
}
.max-h-\\[85px\\] {
  max-height: 85px;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(100vh-2rem\\)\\] {
  max-height: calc(100vh - 2rem);
}
.max-h-\\[calc\\(90vh_-_150px\\)\\] {
  max-height: calc(90vh - 150px);
}
.max-h-full {
  max-height: 100%;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-\\[108px\\] {
  min-height: 108px;
}
.min-h-\\[110px\\] {
  min-height: 110px;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[20px\\] {
  min-height: 20px;
}
.min-h-\\[240px\\] {
  min-height: 240px;
}
.min-h-\\[280px\\] {
  min-height: 280px;
}
.min-h-\\[28px\\] {
  min-height: 28px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[30px\\] {
  min-height: 30px;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[3rem\\] {
  min-height: 3rem;
}
.min-h-\\[42px\\] {
  min-height: 42px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[52px\\] {
  min-height: 52px;
}
.min-h-\\[54px\\] {
  min-height: 54px;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-\\[57px\\] {
  min-height: 57px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[64px\\] {
  min-height: 64px;
}
.min-h-\\[66px\\] {
  min-height: 66px;
}
.min-h-\\[70px\\] {
  min-height: 70px;
}
.min-h-\\[85vh\\] {
  min-height: 85vh;
}
.min-h-\\[calc\\(100vh-2rem\\)\\] {
  min-height: calc(100vh - 2rem);
}
.min-h-\\[calc\\(100vh_-_80px\\)\\] {
  min-height: calc(100vh - 80px);
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/5 {
  width: 20%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[1\\.5px\\] {
  width: 1.5px;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[11\\%\\] {
  width: 11%;
}
.w-\\[11\\.5px\\] {
  width: 11.5px;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[14\\%\\] {
  width: 14%;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[16\\%\\] {
  width: 16%;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200\\%\\] {
  width: 200%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[45px\\] {
  width: 45px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[8px\\] {
  width: 8px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-\\[calc\\(100\\%_-_200px\\)\\] {
  width: calc(100% - 200px);
}
.w-\\[calc\\(100\\%_-_24px\\)\\] {
  width: calc(100% - 24px);
}
.w-\\[calc\\(100\\%_-_300px\\)\\] {
  width: calc(100% - 300px);
}
.w-\\[calc\\(100\\%_-_30px\\)\\] {
  width: calc(100% - 30px);
}
.w-\\[calc\\(100\\%_-_310px\\)\\] {
  width: calc(100% - 310px);
}
.w-\\[calc\\(100vw-32px\\)\\] {
  width: calc(100vw - 32px);
}
.w-\\[calc\\(16\\.66\\%_-_20px\\)\\] {
  width: calc(16.66% - 20px);
}
.w-\\[calc\\(33\\.33\\%-2px\\)\\] {
  width: calc(33.33% - 2px);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.\\!min-w-0 {
  min-width: 0px !important;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[110px\\] {
  min-width: 110px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[130px\\] {
  min-width: 130px;
}
.min-w-\\[136px\\] {
  min-width: 136px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[36px\\] {
  min-width: 36px;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[44px\\] {
  min-width: 44px;
}
.min-w-\\[500px\\] {
  min-width: 500px;
}
.min-w-\\[64px\\] {
  min-width: 64px;
}
.min-w-\\[85px\\] {
  min-width: 85px;
}
.min-w-\\[90px\\] {
  min-width: 90px;
}
.min-w-fit {
  min-width: fit-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[130px\\] {
  max-width: 130px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[30\\%\\] {
  max-width: 30%;
}
.max-w-\\[36px\\] {
  max-width: 36px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[440px\\] {
  max-width: 440px;
}
.max-w-\\[450px\\] {
  max-width: 450px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[650px\\] {
  max-width: 650px;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[80px\\] {
  max-width: 80px;
}
.max-w-\\[85px\\] {
  max-width: 85px;
}
.max-w-\\[90px\\] {
  max-width: 90px;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[1\\.2\\] {
  flex: 1.2 1;
}
.flex-\\[2\\] {
  flex: 2 1;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-center {
  transform-origin: center;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2 {
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-12 {
  --tw-rotate: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-3 {
  --tw-rotate: -3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-3 {
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150 {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.01\\] {
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\] {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-1\\] {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-\\[spin_4s_linear_infinite\\] {
  animation: spin 4s linear infinite;
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes gradient-xy {

  0%, 100% {
    background-size: 400% 400%;
    background-position: 0% 0%;
  }

  50% {
    background-size: 200% 200%;
    background-position: 100% 100%;
  }
}
.animate-gradient-xy {
  animation: gradient-xy 6s ease infinite;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.cursor-zoom-in {
  cursor: zoom-in;
}
.touch-manipulation {
  touch-action: manipulation;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.break-inside-avoid {
  page-break-inside: avoid;
  break-inside: avoid;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-rows-\\[0fr\\] {
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\] {
  grid-template-rows: 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-32 {
  gap: 8rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[12px\\] {
  gap: 12px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[8px\\] {
  gap: 8px;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(242 238 238 / var(--tw-divide-opacity, 1));
}
.divide-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-divide-opacity, 1));
}
.divide-primary-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(204 189 189 / var(--tw-divide-opacity, 1));
}
.divide-primary-100\\/60 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(204 189 189 / 0.6);
}
.divide-primary-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(248 246 246 / var(--tw-divide-opacity, 1));
}
.divide-rose-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-divide-opacity, 1));
}
.divide-white\\/50 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(255 255 255 / 0.5);
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overscroll-none {
  overscroll-behavior: none;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[15px\\] {
  border-radius: 15px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[18px\\] {
  border-radius: 18px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[22px\\] {
  border-radius: 22px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[28px\\] {
  border-radius: 28px;
}
.rounded-\\[32px\\] {
  border-radius: 32px;
}
.rounded-\\[40px\\] {
  border-radius: 40px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-3xl {
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-b-\\[11px\\] {
  border-bottom-right-radius: 11px;
  border-bottom-left-radius: 11px;
}
.rounded-b-\\[12px\\] {
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-l-\\[8px\\] {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-\\[8px\\] {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-\\[11px\\] {
  border-top-left-radius: 11px;
  border-top-right-radius: 11px;
}
.rounded-t-\\[12px\\] {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.rounded-t-\\[4px\\] {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-none {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-bl-\\[11px\\] {
  border-bottom-left-radius: 11px;
}
.rounded-bl-none {
  border-bottom-left-radius: 0px;
}
.rounded-br-\\[11px\\] {
  border-bottom-right-radius: 11px;
}
.rounded-tl-sm {
  border-top-left-radius: 0.125rem;
}
.rounded-tr-sm {
  border-top-right-radius: 0.125rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[0\\.5px\\] {
  border-width: 0.5px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-\\[4px\\] {
  border-width: 4px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-8 {
  border-left-width: 8px;
}
.border-l-\\[5px\\] {
  border-left-width: 5px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-\\[\\#00c732\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 199 50 / var(--tw-border-opacity, 1));
}
.border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-100\\/50 {
  border-color: rgb(254 243 199 / 0.5);
}
.border-amber-100\\/60 {
  border-color: rgb(254 243 199 / 0.6);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/70 {
  border-color: rgb(253 230 138 / 0.7);
}
.border-amber-200\\/80 {
  border-color: rgb(253 230 138 / 0.8);
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-600 {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-black-main {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-100\\/50 {
  border-color: rgb(219 234 254 / 0.5);
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/80 {
  border-color: rgb(191 219 254 / 0.8);
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(138 220 255 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(15 82 186 / var(--tw-border-opacity, 1));
}
.border-current {
  border-color: currentColor;
}
.border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-100\\/50 {
  border-color: rgb(209 250 229 / 0.5);
}
.border-emerald-100\\/60 {
  border-color: rgb(209 250 229 / 0.6);
}
.border-emerald-100\\/80 {
  border-color: rgb(209 250 229 / 0.8);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/60 {
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-200\\/80 {
  border-color: rgb(167 243 208 / 0.8);
}
.border-emerald-200\\/90 {
  border-color: rgb(167 243 208 / 0.9);
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-400\\/30 {
  border-color: rgb(52 211 153 / 0.3);
}
.border-emerald-400\\/40 {
  border-color: rgb(52 211 153 / 0.4);
}
.border-emerald-50\\/50 {
  border-color: rgb(236 253 245 / 0.5);
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/80 {
  border-color: rgb(16 185 129 / 0.8);
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(242 238 238 / var(--tw-border-opacity, 1));
}
.border-gray-100\\/30 {
  border-color: rgb(242 238 238 / 0.3);
}
.border-gray-100\\/50 {
  border-color: rgb(242 238 238 / 0.5);
}
.border-gray-100\\/80 {
  border-color: rgb(242 238 238 / 0.8);
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/60 {
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-200\\/70 {
  border-color: rgb(229 231 235 / 0.7);
}
.border-gray-200\\/80 {
  border-color: rgb(229 231 235 / 0.8);
}
.border-gray-200\\/90 {
  border-color: rgb(229 231 235 / 0.9);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-300\\/60 {
  border-color: rgb(209 213 219 / 0.6);
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity, 1));
}
.border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/80 {
  border-color: rgb(199 210 254 / 0.8);
}
.border-indigo-50\\/50 {
  border-color: rgb(238 242 255 / 0.5);
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/30 {
  border-color: rgb(99 102 241 / 0.3);
}
.border-orange-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-100\\/50 {
  border-color: rgb(255 237 213 / 0.5);
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-400\\/50 {
  border-color: rgb(251 146 60 / 0.5);
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 157 77 / var(--tw-border-opacity, 1));
}
.border-orange-600 {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-primary-100 {
  --tw-border-opacity: 1;
  border-color: rgb(204 189 189 / var(--tw-border-opacity, 1));
}
.border-primary-100\\/20 {
  border-color: rgb(204 189 189 / 0.2);
}
.border-primary-100\\/40 {
  border-color: rgb(204 189 189 / 0.4);
}
.border-primary-100\\/50 {
  border-color: rgb(204 189 189 / 0.5);
}
.border-primary-100\\/60 {
  border-color: rgb(204 189 189 / 0.6);
}
.border-primary-100\\/70 {
  border-color: rgb(204 189 189 / 0.7);
}
.border-primary-100\\/80 {
  border-color: rgb(204 189 189 / 0.8);
}
.border-primary-100\\/90 {
  border-color: rgb(204 189 189 / 0.9);
}
.border-primary-200 {
  --tw-border-opacity: 1;
  border-color: rgb(240 122 122 / var(--tw-border-opacity, 1));
}
.border-primary-200\\/60 {
  border-color: rgb(240 122 122 / 0.6);
}
.border-primary-200\\/80 {
  border-color: rgb(240 122 122 / 0.8);
}
.border-primary-200\\/90 {
  border-color: rgb(240 122 122 / 0.9);
}
.border-primary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 232 232 / var(--tw-border-opacity, 1));
}
.border-primary-300\\/30 {
  border-color: rgb(252 232 232 / 0.3);
}
.border-primary-400 {
  --tw-border-opacity: 1;
  border-color: rgb(159 131 131 / var(--tw-border-opacity, 1));
}
.border-primary-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 246 246 / var(--tw-border-opacity, 1));
}
.border-primary-50\\/50 {
  border-color: rgb(248 246 246 / 0.5);
}
.border-primary-500 {
  --tw-border-opacity: 1;
  border-color: rgb(124 96 96 / var(--tw-border-opacity, 1));
}
.border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(230 33 33 / var(--tw-border-opacity, 1));
}
.border-primary-700 {
  --tw-border-opacity: 1;
  border-color: rgb(142 16 16 / var(--tw-border-opacity, 1));
}
.border-purple-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-300 {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.border-purple-400\\/30 {
  border-color: rgb(192 132 252 / 0.3);
}
.border-purple-700\\/50 {
  border-color: rgb(126 34 206 / 0.5);
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-100\\/50 {
  border-color: rgb(254 226 226 / 0.5);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-200\\/80 {
  border-color: rgb(254 202 202 / 0.8);
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-rose-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-100\\/80 {
  border-color: rgb(255 228 230 / 0.8);
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-200\\/80 {
  border-color: rgb(254 205 211 / 0.8);
}
.border-rose-200\\/90 {
  border-color: rgb(254 205 211 / 0.9);
}
.border-rose-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-sky-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-100\\/50 {
  border-color: rgb(241 245 249 / 0.5);
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-success-100 {
  --tw-border-opacity: 1;
  border-color: rgb(240 255 244 / var(--tw-border-opacity, 1));
}
.border-success-500\\/30 {
  border-color: rgb(148 255 175 / 0.3);
}
.border-success-600 {
  --tw-border-opacity: 1;
  border-color: rgb(0 199 50 / var(--tw-border-opacity, 1));
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-teal-200\\/80 {
  border-color: rgb(153 246 228 / 0.8);
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.border-teal-500\\/30 {
  border-color: rgb(20 184 166 / 0.3);
}
.border-transparent {
  border-color: transparent;
}
.border-web-border {
  --tw-border-opacity: 1;
  border-color: rgb(234 228 217 / var(--tw-border-opacity, 1));
}
.border-web-border\\/10 {
  border-color: rgb(234 228 217 / 0.1);
}
.border-web-border\\/20 {
  border-color: rgb(234 228 217 / 0.2);
}
.border-web-border\\/30 {
  border-color: rgb(234 228 217 / 0.3);
}
.border-web-border\\/40 {
  border-color: rgb(234 228 217 / 0.4);
}
.border-web-border\\/50 {
  border-color: rgb(234 228 217 / 0.5);
}
.border-web-border\\/60 {
  border-color: rgb(234 228 217 / 0.6);
}
.border-web-border\\/80 {
  border-color: rgb(234 228 217 / 0.8);
}
.border-web-primary {
  --tw-border-opacity: 1;
  border-color: rgb(209 52 56 / var(--tw-border-opacity, 1));
}
.border-web-primary\\/10 {
  border-color: rgb(209 52 56 / 0.1);
}
.border-web-secondary\\/20 {
  border-color: rgb(210 200 184 / 0.2);
}
.border-web-secondary\\/30 {
  border-color: rgb(210 200 184 / 0.3);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15 {
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/50 {
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/60 {
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 249 219 / var(--tw-border-opacity, 1));
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-yellow-400\\/30 {
  border-color: rgb(250 204 21 / 0.3);
}
.border-l-amber-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-l-blue-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(15 82 186 / var(--tw-border-opacity, 1));
}
.border-l-emerald-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-l-indigo-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-l-primary-300 {
  --tw-border-opacity: 1;
  border-left-color: rgb(252 232 232 / var(--tw-border-opacity, 1));
}
.border-l-rose-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-l-success-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(148 255 175 / var(--tw-border-opacity, 1));
}
.border-l-teal-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.border-l-yellow-400 {
  --tw-border-opacity: 1;
  border-left-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-t-primary-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(230 33 33 / var(--tw-border-opacity, 1));
}
.border-t-red-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#0a1128\\]\\/35 {
  background-color: rgb(10 17 40 / 0.35);
}
.bg-\\[\\#0a1128\\]\\/85 {
  background-color: rgb(10 17 40 / 0.85);
}
.bg-\\[\\#141010\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 16 16 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E1C1A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 28 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4dff79\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(77 255 121 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#54ddd5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(84 221 213 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6b70dd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(107 112 221 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#9F8383\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(159 131 131 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E4DCDC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 220 220 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EFEBE1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 235 225 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EFEBE1\\]\\/60 {
  background-color: rgb(239 235 225 / 0.6);
}
.bg-\\[\\#F2EEEE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 238 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F9FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9F8F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 248 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9F8F6\\]\\/80 {
  background-color: rgb(249 248 246 / 0.8);
}
.bg-\\[\\#FAF9F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCFBFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 251 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEFEFE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d2dd56\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(210 221 86 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0fff4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 255 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f2ec\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 242 236 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fdfdfd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-100\\/70 {
  background-color: rgb(254 243 199 / 0.7);
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/40 {
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/50 {
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/70 {
  background-color: rgb(255 251 235 / 0.7);
}
.bg-amber-50\\/80 {
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-100\\/30 {
  background-color: rgb(219 234 254 / 0.3);
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(138 220 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/30 {
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-50\\/70 {
  background-color: rgb(239 246 255 / 0.7);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 82 186 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-current {
  background-color: currentColor;
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100\\/80 {
  background-color: rgb(209 250 229 / 0.8);
}
.bg-emerald-100\\/90 {
  background-color: rgb(209 250 229 / 0.9);
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40 {
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/50 {
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-50\\/60 {
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-50\\/70 {
  background-color: rgb(236 253 245 / 0.7);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/20 {
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(242 238 238 / var(--tw-bg-opacity, 1));
}
.bg-gray-100\\/60 {
  background-color: rgb(242 238 238 / 0.6);
}
.bg-gray-100\\/80 {
  background-color: rgb(242 238 238 / 0.8);
}
.bg-gray-100\\/90 {
  background-color: rgb(242 238 238 / 0.9);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-200\\/60 {
  background-color: rgb(229 231 235 / 0.6);
}
.bg-gray-200\\/70 {
  background-color: rgb(229 231 235 / 0.7);
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/30 {
  background-color: rgb(249 250 251 / 0.3);
}
.bg-gray-50\\/50 {
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-50\\/60 {
  background-color: rgb(249 250 251 / 0.6);
}
.bg-gray-50\\/70 {
  background-color: rgb(249 250 251 / 0.7);
}
.bg-gray-50\\/80 {
  background-color: rgb(249 250 251 / 0.8);
}
.bg-gray-50\\/90 {
  background-color: rgb(249 250 251 / 0.9);
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-gray-900\\/40 {
  background-color: rgb(17 24 39 / 0.4);
}
.bg-gray-900\\/60 {
  background-color: rgb(17 24 39 / 0.6);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-100\\/40 {
  background-color: rgb(220 252 231 / 0.4);
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/70 {
  background-color: rgb(238 242 255 / 0.7);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-neutral-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 157 77 / var(--tw-bg-opacity, 1));
}
.bg-orange-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(199 90 0 / var(--tw-bg-opacity, 1));
}
.bg-pink-200\\/40 {
  background-color: rgb(251 207 232 / 0.4);
}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 189 189 / var(--tw-bg-opacity, 1));
}
.bg-primary-100\\/40 {
  background-color: rgb(204 189 189 / 0.4);
}
.bg-primary-100\\/70 {
  background-color: rgb(204 189 189 / 0.7);
}
.bg-primary-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 122 122 / var(--tw-bg-opacity, 1));
}
.bg-primary-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 232 / var(--tw-bg-opacity, 1));
}
.bg-primary-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(159 131 131 / var(--tw-bg-opacity, 1));
}
.bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 246 246 / var(--tw-bg-opacity, 1));
}
.bg-primary-50\\/20 {
  background-color: rgb(248 246 246 / 0.2);
}
.bg-primary-50\\/30 {
  background-color: rgb(248 246 246 / 0.3);
}
.bg-primary-50\\/40 {
  background-color: rgb(248 246 246 / 0.4);
}
.bg-primary-50\\/50 {
  background-color: rgb(248 246 246 / 0.5);
}
.bg-primary-50\\/60 {
  background-color: rgb(248 246 246 / 0.6);
}
.bg-primary-50\\/70 {
  background-color: rgb(248 246 246 / 0.7);
}
.bg-primary-50\\/80 {
  background-color: rgb(248 246 246 / 0.8);
}
.bg-primary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 96 96 / var(--tw-bg-opacity, 1));
}
.bg-primary-500\\/10 {
  background-color: rgb(124 96 96 / 0.1);
}
.bg-primary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(230 33 33 / var(--tw-bg-opacity, 1));
}
.bg-primary-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(142 16 16 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/70 {
  background-color: rgb(250 245 255 / 0.7);
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/30 {
  background-color: rgb(168 85 247 / 0.3);
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.bg-red-200\\/40 {
  background-color: rgb(254 202 202 / 0.4);
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/50 {
  background-color: rgb(254 242 242 / 0.5);
}
.bg-red-50\\/70 {
  background-color: rgb(254 242 242 / 0.7);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/90 {
  background-color: rgb(220 38 38 / 0.9);
}
.bg-rose-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-100\\/50 {
  background-color: rgb(255 228 230 / 0.5);
}
.bg-rose-100\\/70 {
  background-color: rgb(255 228 230 / 0.7);
}
.bg-rose-200\\/40 {
  background-color: rgb(254 205 211 / 0.4);
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/40 {
  background-color: rgb(255 241 242 / 0.4);
}
.bg-rose-50\\/50 {
  background-color: rgb(255 241 242 / 0.5);
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-sky-200\\/80 {
  background-color: rgb(186 230 253 / 0.8);
}
.bg-sky-50\\/70 {
  background-color: rgb(240 249 255 / 0.7);
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/70 {
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80 {
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-900\\/60 {
  background-color: rgb(15 23 42 / 0.6);
}
.bg-success-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 255 244 / var(--tw-bg-opacity, 1));
}
.bg-success-100\\/20 {
  background-color: rgb(240 255 244 / 0.2);
}
.bg-success-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 255 175 / var(--tw-bg-opacity, 1));
}
.bg-success-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 199 50 / var(--tw-bg-opacity, 1));
}
.bg-success-600\\/20 {
  background-color: rgb(0 199 50 / 0.2);
}
.bg-success-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(77 255 121 / var(--tw-bg-opacity, 1));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-web-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 246 / var(--tw-bg-opacity, 1));
}
.bg-web-bg\\/50 {
  background-color: rgb(250 249 246 / 0.5);
}
.bg-web-border {
  --tw-bg-opacity: 1;
  background-color: rgb(234 228 217 / var(--tw-bg-opacity, 1));
}
.bg-web-border\\/20 {
  background-color: rgb(234 228 217 / 0.2);
}
.bg-web-border\\/30 {
  background-color: rgb(234 228 217 / 0.3);
}
.bg-web-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(209 52 56 / var(--tw-bg-opacity, 1));
}
.bg-web-primary\\/10 {
  background-color: rgb(209 52 56 / 0.1);
}
.bg-web-primary\\/5 {
  background-color: rgb(209 52 56 / 0.05);
}
.bg-web-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(210 200 184 / var(--tw-bg-opacity, 1));
}
.bg-web-secondary\\/10 {
  background-color: rgb(210 200 184 / 0.1);
}
.bg-web-secondary\\/15 {
  background-color: rgb(210 200 184 / 0.15);
}
.bg-web-secondary\\/20 {
  background-color: rgb(210 200 184 / 0.2);
}
.bg-web-text {
  --tw-bg-opacity: 1;
  background-color: rgb(44 42 41 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100\\/20 {
  background-color: rgb(255 249 219 / 0.2);
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 226 77 / var(--tw-bg-opacity, 1));
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.bg-opacity-95 {
  --tw-bg-opacity: 0.95;
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-amber-400 {
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50 {
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50\\/50 {
  --tw-gradient-from: rgb(255 251 235 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500 {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/20 {
  --tw-gradient-from: rgb(239 246 255 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400 {
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/30 {
  --tw-gradient-from: rgb(236 253 245 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/90 {
  --tw-gradient-from: rgb(236 253 245 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50\\/80 {
  --tw-gradient-from: rgb(249 250 251 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50 {
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500 {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50 {
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50\\/50 {
  --tw-gradient-from: rgb(255 247 237 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50\\/60 {
  --tw-gradient-from: rgb(255 247 237 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-400 {
  --tw-gradient-from: #9F8383 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(159 131 131 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-50 {
  --tw-gradient-from: #F8F6F6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 246 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-50\\/40 {
  --tw-gradient-from: rgb(248 246 246 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 246 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-50\\/90 {
  --tw-gradient-from: rgb(248 246 246 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 246 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-600 {
  --tw-gradient-from: #E62121 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(230 33 33 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50\\/50 {
  --tw-gradient-from: rgb(250 245 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-900 {
  --tw-gradient-from: #581c87 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-50\\/50 {
  --tw-gradient-from: rgb(254 242 242 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-web-primary {
  --tw-gradient-from: #D13438 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 52 56 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #ffffff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-emerald-50\\/20 {
  --tw-gradient-to: rgb(236 253 245 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(236 253 245 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-900 {
  --tw-gradient-to: rgb(49 46 129 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #312e81 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary-50\\/50 {
  --tw-gradient-to: rgb(248 246 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(248 246 246 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-50 {
  --tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #faf5ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500 {
  --tw-gradient-to: rgb(20 184 166 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #14b8a6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ffffff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-50\\/20 {
  --tw-gradient-to: rgb(255 251 235 / 0.2) var(--tw-gradient-to-position);
}
.to-amber-50\\/30 {
  --tw-gradient-to: rgb(255 251 235 / 0.3) var(--tw-gradient-to-position);
}
.to-amber-500 {
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}
.to-emerald-50\\/10 {
  --tw-gradient-to: rgb(236 253 245 / 0.1) var(--tw-gradient-to-position);
}
.to-emerald-50\\/40 {
  --tw-gradient-to: rgb(236 253 245 / 0.4) var(--tw-gradient-to-position);
}
.to-emerald-600 {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-emerald-950 {
  --tw-gradient-to: #022c22 var(--tw-gradient-to-position);
}
.to-gray-50\\/30 {
  --tw-gradient-to: rgb(249 250 251 / 0.3) var(--tw-gradient-to-position);
}
.to-gray-800 {
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}
.to-green-50\\/20 {
  --tw-gradient-to: rgb(240 253 244 / 0.2) var(--tw-gradient-to-position);
}
.to-indigo-600 {
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-orange-50 {
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #FF9D4D var(--tw-gradient-to-position);
}
.to-pink-50 {
  --tw-gradient-to: #fdf2f8 var(--tw-gradient-to-position);
}
.to-primary-50\\/20 {
  --tw-gradient-to: rgb(248 246 246 / 0.2) var(--tw-gradient-to-position);
}
.to-primary-50\\/80 {
  --tw-gradient-to: rgb(248 246 246 / 0.8) var(--tw-gradient-to-position);
}
.to-primary-600 {
  --tw-gradient-to: #E62121 var(--tw-gradient-to-position);
}
.to-primary-700 {
  --tw-gradient-to: #8E1010 var(--tw-gradient-to-position);
}
.to-purple-950 {
  --tw-gradient-to: #3b0764 var(--tw-gradient-to-position);
}
.to-red-50\\/30 {
  --tw-gradient-to: rgb(254 242 242 / 0.3) var(--tw-gradient-to-position);
}
.to-rose-50\\/30 {
  --tw-gradient-to: rgb(255 241 242 / 0.3) var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-web-secondary {
  --tw-gradient-to: #D2C8B8 var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);
}
.bg-\\[length\\:200\\%_200\\%\\] {
  background-size: 200% 200%;
}
.bg-\\[right_8px_center\\] {
  background-position: right 8px center;
}
.stroke-current {
  stroke: currentColor;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-2 {
  padding: 0.5rem !important;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[12px\\] {
  padding: 12px;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[25px\\] {
  padding-left: 25px;
  padding-right: 25px;
}
.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[22px\\] {
  padding-top: 22px;
  padding-bottom: 22px;
}
.py-\\[24px\\] {
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[20px\\] {
  padding-bottom: 20px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-14 {
  padding-left: 3.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-3\\.5 {
  padding-left: 0.875rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[42px\\] {
  padding-left: 42px;
}
.pl-\\[96px\\] {
  padding-left: 96px;
}
.pr-0 {
  padding-right: 0px;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-3\\.5 {
  padding-right: 0.875rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-\\[25px\\] {
  padding-right: 25px;
}
.pr-\\[30px\\] {
  padding-right: 30px;
}
.pr-\\[40px\\] {
  padding-right: 40px;
}
.pr-\\[86px\\] {
  padding-right: 86px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[30px\\] {
  padding-top: 30px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-web-sans {
  font-family: 'Outfit', sans-serif;
}
.font-web-serif {
  font-family: 'Crimson Text', serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10\\.5px\\] {
  font-size: 10.5px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[7\\.5px\\] {
  font-size: 7.5px;
}
.text-\\[8\\.5px\\] {
  font-size: 8.5px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9\\.5px\\] {
  font-size: 9.5px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-\\[20px\\] {
  line-height: 20px;
}
.leading-\\[30px\\] {
  line-height: 30px;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.1em\\] {
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#789A9B\\] {
  --tw-text-opacity: 1;
  color: rgb(120 154 155 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F1C40F\\] {
  --tw-text-opacity: 1;
  color: rgb(241 196 15 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF7F6A\\] {
  --tw-text-opacity: 1;
  color: rgb(255 127 106 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-700\\/80 {
  color: rgb(180 83 9 / 0.8);
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-black-lose {
  --tw-text-opacity: 1;
  color: rgb(40 31 31 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(15 82 186 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-current {
  color: currentColor;
}
.text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-700\\/80 {
  color: rgb(4 120 87 / 0.8);
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-gray-950 {
  --tw-text-opacity: 1;
  color: rgb(3 7 18 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 157 77 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-600\\/80 {
  color: rgb(234 88 12 / 0.8);
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(199 90 0 / var(--tw-text-opacity, 1));
}
.text-primary-100 {
  --tw-text-opacity: 1;
  color: rgb(204 189 189 / var(--tw-text-opacity, 1));
}
.text-primary-200 {
  --tw-text-opacity: 1;
  color: rgb(240 122 122 / var(--tw-text-opacity, 1));
}
.text-primary-300 {
  --tw-text-opacity: 1;
  color: rgb(252 232 232 / var(--tw-text-opacity, 1));
}
.text-primary-400 {
  --tw-text-opacity: 1;
  color: rgb(159 131 131 / var(--tw-text-opacity, 1));
}
.text-primary-50 {
  --tw-text-opacity: 1;
  color: rgb(248 246 246 / var(--tw-text-opacity, 1));
}
.text-primary-500 {
  --tw-text-opacity: 1;
  color: rgb(124 96 96 / var(--tw-text-opacity, 1));
}
.text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(230 33 33 / var(--tw-text-opacity, 1));
}
.text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(142 16 16 / var(--tw-text-opacity, 1));
}
.text-purple-200 {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-500\\/30 {
  color: rgb(239 68 68 / 0.3);
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800 {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-900 {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-secondry-600 {
  --tw-text-opacity: 1;
  color: rgb(81 62 62 / var(--tw-text-opacity, 1));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-900 {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-success-500 {
  --tw-text-opacity: 1;
  color: rgb(148 255 175 / var(--tw-text-opacity, 1));
}
.text-success-600 {
  --tw-text-opacity: 1;
  color: rgb(0 199 50 / var(--tw-text-opacity, 1));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-web-border\\/80 {
  color: rgb(234 228 217 / 0.8);
}
.text-web-primary {
  --tw-text-opacity: 1;
  color: rgb(209 52 56 / var(--tw-text-opacity, 1));
}
.text-web-secondary {
  --tw-text-opacity: 1;
  color: rgb(210 200 184 / var(--tw-text-opacity, 1));
}
.text-web-secondary\\/80 {
  color: rgb(210 200 184 / 0.8);
}
.text-web-text {
  --tw-text-opacity: 1;
  color: rgb(44 42 41 / var(--tw-text-opacity, 1));
}
.text-web-text\\/10 {
  color: rgb(44 42 41 / 0.1);
}
.text-web-text\\/20 {
  color: rgb(44 42 41 / 0.2);
}
.text-web-text\\/30 {
  color: rgb(44 42 41 / 0.3);
}
.text-web-text\\/40 {
  color: rgb(44 42 41 / 0.4);
}
.text-web-text\\/50 {
  color: rgb(44 42 41 / 0.5);
}
.text-web-text\\/60 {
  color: rgb(44 42 41 / 0.6);
}
.text-web-text\\/70 {
  color: rgb(44 42 41 / 0.7);
}
.text-web-text\\/80 {
  color: rgb(44 42 41 / 0.8);
}
.text-web-text\\/90 {
  color: rgb(44 42 41 / 0.9);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/40 {
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(199 166 0 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(199 166 0 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.accent-primary-600 {
  accent-color: #E62121;
}
.accent-web-primary {
  accent-color: #D13438;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-85 {
  opacity: 0.85;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-95 {
  opacity: 0.95;
}
.opacity-\\[0\\.03\\] {
  opacity: 0.03;
}
.mix-blend-multiply {
  mix-blend-mode: multiply;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_20px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\] {
  --tw-shadow: 0 -4px 20px rgb(0,0,0,0.02);
  --tw-shadow-colored: 0 -4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_4px_rgba\\(245\\2c 158\\2c 11\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 0 4px rgba(245,158,11,0.5);
  --tw-shadow-colored: 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_4px_rgba\\(34\\2c 197\\2c 94\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 0 4px rgba(34,197,94,0.5);
  --tw-shadow-colored: 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(34\\2c 197\\2c 94\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 0 8px rgba(34,197,94,0.6);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_-10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 10px 40px -10px rgba(0,0,0,0.15);
  --tw-shadow-colored: 0 10px 40px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 20px 50px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_32px_120px_-20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 32px 120px -20px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 32px 120px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.09\\)\\] {
  --tw-shadow: 0 5px 10px rgba(0,0,0,0.09);
  --tw-shadow-colored: 0 5px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.09\\)\\] {
  --tw-shadow: 0 5px 8px rgba(0,0,0,0.09);
  --tw-shadow-colored: 0 5px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 8px 30px rgb(0,0,0,0.04);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 8px 30px rgb(0,0,0,0.06);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 8px 30px rgb(0,0,0,0.08);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_4px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\] {
  --tw-shadow: inset 0 4px 4px rgba(0,0,0,0.18);
  --tw-shadow-colored: inset 0 4px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-500\\/50 {
  --tw-shadow-color: rgb(245 158 11 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-100 {
  --tw-shadow-color: #d1fae5;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/10 {
  --tw-shadow-color: rgb(16 185 129 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/50 {
  --tw-shadow-color: rgb(16 185 129 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/20 {
  --tw-shadow-color: rgb(5 150 105 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/30 {
  --tw-shadow-color: rgb(5 150 105 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-100\\/50 {
  --tw-shadow-color: rgb(220 252 231 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-200 {
  --tw-shadow-color: #bbf7d0;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-50\\/50 {
  --tw-shadow-color: rgb(240 253 244 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/10 {
  --tw-shadow-color: rgb(34 197 94 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-100 {
  --tw-shadow-color: #e0e7ff;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-100 {
  --tw-shadow-color: #CCBDBD;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-100\\/50 {
  --tw-shadow-color: rgb(204 189 189 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-200 {
  --tw-shadow-color: #F07A7A;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-50 {
  --tw-shadow-color: #F8F6F6;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-600\\/20 {
  --tw-shadow-color: rgb(230 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-100 {
  --tw-shadow-color: #fee2e2;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-200 {
  --tw-shadow-color: #fecaca;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-web-primary\\/15 {
  --tw-shadow-color: rgb(209 52 56 / 0.15);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-web-primary\\/20 {
  --tw-shadow-color: rgb(209 52 56 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-web-primary\\/25 {
  --tw-shadow-color: rgb(209 52 56 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-web-primary\\/30 {
  --tw-shadow-color: rgb(209 52 56 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-web-primary\\/5 {
  --tw-shadow-color: rgb(209 52 56 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-amber-400\\/20 {
  --tw-ring-color: rgb(251 191 36 / 0.2);
}
.ring-amber-500\\/10 {
  --tw-ring-color: rgb(245 158 11 / 0.1);
}
.ring-emerald-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.ring-emerald-400\\/20 {
  --tw-ring-color: rgb(52 211 153 / 0.2);
}
.ring-emerald-500\\/10 {
  --tw-ring-color: rgb(16 185 129 / 0.1);
}
.ring-green-400\\/20 {
  --tw-ring-color: rgb(74 222 128 / 0.2);
}
.ring-primary-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(204 189 189 / var(--tw-ring-opacity, 1));
}
.ring-primary-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 122 122 / var(--tw-ring-opacity, 1));
}
.ring-primary-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 232 232 / var(--tw-ring-opacity, 1));
}
.ring-primary-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(159 131 131 / var(--tw-ring-opacity, 1));
}
.ring-primary-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(124 96 96 / var(--tw-ring-opacity, 1));
}
.ring-primary-500\\/10 {
  --tw-ring-color: rgb(124 96 96 / 0.1);
}
.ring-primary-500\\/20 {
  --tw-ring-color: rgb(124 96 96 / 0.2);
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/50 {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.ring-offset-1 {
  --tw-ring-offset-width: 1px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\] {
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[120px\\] {
  --tw-blur: blur(120px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[150px\\] {
  --tw-blur: blur(150px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[80px\\] {
  --tw-blur: blur(80px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[-webkit-mask-image\\:linear-gradient\\(to_bottom\\2c transparent\\2c black_15\\%\\2c black_85\\%\\2c transparent\\)\\] {
  -webkit-mask-image: linear-gradient(to bottom,transparent,black 15%,black 85%,transparent);
}
.\\[mask-image\\:linear-gradient\\(to_bottom\\2c transparent\\2c black_15\\%\\2c black_85\\%\\2c transparent\\)\\] {
  mask-image: linear-gradient(to bottom,transparent,black 15%,black 85%,transparent);
}

/* Hide native video controls, especially the iOS Safari large play button overlay */
video::-webkit-media-controls {
  display: none !important;
}
video::-webkit-media-controls-start-playback-button {
  display: none !important;
}
video::-webkit-media-controls-enclosure {
  display: none !important;
}
video::-webkit-media-controls-overlay-play-button {
  display: none !important;
}

body {
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}

.container {
  margin: 0 auto;
}

table {
  width: 100%;
}

td {
  padding: 4px 0;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #513e3e;
}

.billing-table td:nth-child(2) {
  color: #281f1f;
  text-align: right;
}

th {
  padding: 8px 0;
  text-align: left;
  font-weight: 500;
  font-size: 16px;
  color: #281f1f;
  border-top: 1px solid #ccbdbd;
}

th:nth-child(2) {
  padding: 4px 0;
  text-align: right;
}

.cus-checkbox {
  display: block;
  position: relative;
}

.cus-checkbox input {
  padding: 0;
  height: 100%;
  width: 100%;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
  position: absolute;
}

.cus-checkbox label {
  position: relative;
  cursor: pointer;
}

.cus-checkbox span {
  height: 24px;
  width: 24px;
  flex: 0 0 24px;
  display: block;
  border: 1px solid #f07a7a;
  border-radius: 4px;
  background-color: #fce8e8;
  position: relative;
  cursor: pointer;
  transition: all 250ms ease-in-out;
}

html,
body {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

::-webkit-scrollbar {
  display: none;
}

.cus-checkbox input:checked+span {
  background-color: #e62121;
  border-color: #e62121;
}

.cus-checkbox span:after {
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 9px;
  width: 6px;
  height: 14px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: all 250ms ease-in-out;
}

.cus-checkbox input:checked+span:after {
  opacity: 1;
}

.cus-radio span {
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f07a7a;
  border-radius: 24px;
  background-color: #fce8e8;
  position: relative;
  cursor: pointer;
  transition: all 250ms ease-in-out;
}

.cus-radio span:after {
  content: "";
  display: block;
  position: absolute;
  background: #fff;
  width: 16px;
  height: 16px;
  border-radius: 20px;
  opacity: 0;
  transition: all 250ms ease-in-out;
}

.cus-radio input:checked+span {
  background-color: #e62121;
  border-color: #e62121;
}

.cus-radio input:checked+span:after {
  opacity: 1;
}

/* Tooltip container */
.tooltip-container {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-text {
  visibility: hidden;
  width: 120px;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  /* Position above the element */
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

/* Show the tooltip text when hovering */
.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.admin-table {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  /* Ensures the sticky elements are within the correct positioning context */
  /* max-height: 600px;  */
}

.admin-table th {
  padding: 8px 16px;
  color: #281f1f;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #ccc;
  background: #f2eeee;
  text-align: left;
  white-space: nowrap;
  position: sticky;
  /* Sticky headers */
  top: 0;
  /* Ensures the header stays at the top */
  z-index: 1;
  /* Ensures headers are above rows */
}

.admin-table td {
  padding: 8px 16px;
  color: #513e3e;
  font-size: 16px;
  font-weight: 400;
  border: 1px solid #ccc;
  background: #f8f6f6;
}

.admin-table tr th:nth-child(1),
.admin-table tr td:nth-child(1) {
  border-left: none;
}

.admin-table tr th:nth-last-child(1),
.admin-table tr td:nth-last-child(1) {
  border-right: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.medicine-table table {
  border: none;
}

.medicine-table table th {
  color: #9f8383;
  font-size: 16px;
  font-weight: normal;
}

.medicine-table table th,
.medicine-table table td {
  padding: 8px 5px;
  text-align: left;
  border: none;
}

.medicine-table table th:nth-child(1),
.medicine-table table th:nth-child(2),
.medicine-table table th:nth-child(3),
.medicine-table table th:nth-child(4),
.medicine-table table td:nth-child(1),
.medicine-table table td:nth-child(2),
.medicine-table table td:nth-child(3),
.medicine-table table td:nth-child(4) {
  width: 60px;
}

.loader {
  display: flex;
  column-gap: 5px;
  margin: 0 auto 12px;
  justify-content: center;
}

.loader .load-circle {
  width: 8px;
  height: 8px;
  background-color: black;
  border-radius: 50%;
  animation: loading 500ms infinite alternate;
}

.loader .load-circle:nth-child(1) {
  animation-delay: -250ms;
}

.loader .load-circle:nth-child(2) {
  animation-delay: -500ms;
}

.loader .load-circle:nth-child(3) {
  animation-delay: -750ms;
}

@keyframes loading {
  0% {
    transform: translateY(-8px);
  }

  100% {
    transform: translateY(5px);
  }
}

.health-loader {
  color: #1e1e1e;
  color: currentColor;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.health-loader div {
  transform-origin: 40px 40px;
  animation: WheelLoader 1.4s linear infinite;
}

.health-loader div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 10px;
  left: 36.8px;
  width: 6px;
  height: 18px;
  border-radius: 20px;
  background: #1e1e1e;
}

.health-loader div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.6s;
}

.health-loader div:nth-child(2) {
  transform: rotate(46deg);
  animation-delay: -1.4s;
}

.health-loader div:nth-child(3) {
  transform: rotate(92deg);
  animation-delay: -1.2s;
}

.health-loader div:nth-child(4) {
  transform: rotate(138deg);
  animation-delay: -1s;
}

.health-loader div:nth-child(5) {
  transform: rotate(184deg);
  animation-delay: -0.8s;
}

.health-loader div:nth-child(6) {
  transform: rotate(230deg);
  animation-delay: -0.6s;
}

.health-loader div:nth-child(7) {
  transform: rotate(270deg);
  animation-delay: -0.4s;
}

.health-loader div:nth-child(8) {
  transform: rotate(320deg);
  animation-delay: -0.4s;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: 1px solid transparent;
  -webkit-text-fill-color: #281f1f;
  box-shadow: 0 0 0px 1000px transparent inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  color: #281f1f;
}

select {
  appearance: none;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 28px 28px;
  background-position: center right 5px;
  width: 100%;
  padding-right: 40px !important;
}

select:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.react-date-picker__wrapper {
  border: none !important;
}

.react-date-picker__wrapper input {
  outline: none !important;
  background: transparent !important;
  border: none !important;
}

@keyframes WheelLoader {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.react-datepicker-popper {
  right: 0;
  left: auto !important;
  transform: translate(0px, 56px) !important;
}

.react-date-picker__button:enabled:hover .react-date-picker__button__icon,
.react-date-picker__button:enabled:focus .react-date-picker__button__icon {
  stroke: #b2a2a2 !important;
}

/* Large checkbox (80px) checkmark centering */
.cus-checkbox span[style*="height: '80px'"]::after {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) rotate(45deg) !important;
  width: 12px !important;
  height: 24px !important;
  border-width: 0 3px 3px 0 !important;
}

@keyframes gradient-xy {

  0%,
  100% {
    background-size: 400% 400%;
    background-position: left center;
  }

  50% {
    background-size: 200% 200%;
    background-position: right center;
  }
}

.animate-gradient-xy {
  animation: gradient-xy 3s ease infinite;
}

.thin-scrollbar::-webkit-scrollbar {
  width: 4px;
}

.thin-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.thin-scrollbar::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 10px;
}

.thin-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Robust single-container infinite marquee animations */
.animate-marquee-infinite {
  animation: marquee-infinite 100s linear infinite;
}

.animate-marquee-infinite-fast {
  animation: marquee-infinite 85s linear infinite;
}

.animate-marquee-infinite-reverse {
  animation: marquee-infinite-reverse 100s linear infinite;
}

@keyframes marquee-infinite {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes marquee-infinite-reverse {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}
@keyframes logo-zoom-pulse {
  0%, 100% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
}

.animate-logo-zoom {
  animation: logo-zoom-pulse 2s ease-in-out infinite;
}

.selection\\:bg-primary-600 *::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(230 33 33 / var(--tw-bg-opacity, 1));
}

.selection\\:bg-web-primary *::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(209 52 56 / var(--tw-bg-opacity, 1));
}

.selection\\:text-white *::selection {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.selection\\:bg-primary-600::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(230 33 33 / var(--tw-bg-opacity, 1));
}

.selection\\:bg-web-primary::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(209 52 56 / var(--tw-bg-opacity, 1));
}

.selection\\:text-white::selection {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-\\[16px\\]::placeholder {
  font-size: 16px;
}

.placeholder\\:font-normal::placeholder {
  font-weight: 400;
}

.placeholder\\:text-gray-300::placeholder {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-primary-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(159 131 131 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-primary-700::placeholder {
  --tw-text-opacity: 1;
  color: rgb(142 16 16 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-secondry-600::placeholder {
  --tw-text-opacity: 1;
  color: rgb(81 62 62 / var(--tw-text-opacity, 1));
}

.placeholder\\:opacity-50::placeholder {
  opacity: 0.5;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:-left-\\[1px\\]::before {
  content: var(--tw-content);
  left: -1px;
}

.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:h-\\[4px\\]::before {
  content: var(--tw-content);
  height: 4px;
}

.before\\:w-\\[4px\\]::before {
  content: var(--tw-content);
  width: 4px;
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-primary-600::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(230 33 33 / var(--tw-bg-opacity, 1));
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-right-\\[1px\\]::after {
  content: var(--tw-content);
  right: -1px;
}

.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}

.after\\:start-\\[2px\\]::after {
  content: var(--tw-content);
  inset-inline-start: 2px;
}

.after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}

.after\\:block::after {
  content: var(--tw-content);
  display: block;
}

.after\\:h-3::after {
  content: var(--tw-content);
  height: 0.75rem;
}

.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}

.after\\:h-\\[4px\\]::after {
  content: var(--tw-content);
  height: 4px;
}

.after\\:w-3::after {
  content: var(--tw-content);
  width: 0.75rem;
}

.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}

.after\\:w-\\[4px\\]::after {
  content: var(--tw-content);
  width: 4px;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}

.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.after\\:bg-primary-600::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(230 33 33 / var(--tw-bg-opacity, 1));
}

.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.first\\:pt-0:first-child {
  padding-top: 0px;
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.focus-within\\:border:focus-within {
  border-width: 1px;
}

.focus-within\\:border-primary-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(124 96 96 / var(--tw-border-opacity, 1));
}

.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-2\\.5:hover {
  --tw-translate-y: -0.625rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-y-\\[-4px\\]:hover {
  --tw-translate-y: -4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-amber-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}

.hover\\:border-amber-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-emerald-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}

.hover\\:border-emerald-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(204 189 189 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(240 122 122 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 232 232 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(159 131 131 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(230 33 33 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(142 16 16 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}

.hover\\:border-rose-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 199 50 / var(--tw-border-opacity, 1));
}

.hover\\:border-web-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 52 56 / var(--tw-border-opacity, 1));
}

.hover\\:border-web-primary\\/30:hover {
  border-color: rgb(209 52 56 / 0.3);
}

.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-100\\/50:hover {
  background-color: rgb(254 243 199 / 0.5);
}

.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-50\\/50:hover {
  background-color: rgb(255 251 235 / 0.5);
}

.hover\\:bg-amber-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100\\/50:hover {
  background-color: rgb(219 234 254 / 0.5);
}

.hover\\:bg-blue-50\\/50:hover {
  background-color: rgb(239 246 255 / 0.5);
}

.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-100\\/50:hover {
  background-color: rgb(209 250 229 / 0.5);
}

.hover\\:bg-emerald-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-50\\/70:hover {
  background-color: rgb(236 253 245 / 0.7);
}

.hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 238 238 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100\\/70:hover {
  background-color: rgb(242 238 238 / 0.7);
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50\\/70:hover {
  background-color: rgb(249 250 251 / 0.7);
}

.hover\\:bg-gray-50\\/80:hover {
  background-color: rgb(249 250 251 / 0.8);
}

.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(204 189 189 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-100\\/50:hover {
  background-color: rgb(204 189 189 / 0.5);
}

.hover\\:bg-primary-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 122 122 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 246 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-50\\/10:hover {
  background-color: rgb(248 246 246 / 0.1);
}

.hover\\:bg-primary-50\\/30:hover {
  background-color: rgb(248 246 246 / 0.3);
}

.hover\\:bg-primary-50\\/40:hover {
  background-color: rgb(248 246 246 / 0.4);
}

.hover\\:bg-primary-50\\/50:hover {
  background-color: rgb(248 246 246 / 0.5);
}

.hover\\:bg-primary-50\\/60:hover {
  background-color: rgb(248 246 246 / 0.6);
}

.hover\\:bg-primary-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 33 33 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(142 16 16 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-700\\/50:hover {
  background-color: rgb(142 16 16 / 0.5);
}

.hover\\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50\\/50:hover {
  background-color: rgb(254 242 242 / 0.5);
}

.hover\\:bg-red-500\\/15:hover {
  background-color: rgb(239 68 68 / 0.15);
}

.hover\\:bg-red-500\\/25:hover {
  background-color: rgb(239 68 68 / 0.25);
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-100\\/50:hover {
  background-color: rgb(255 228 230 / 0.5);
}

.hover\\:bg-rose-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50\\/20:hover {
  background-color: rgb(255 241 242 / 0.2);
}

.hover\\:bg-rose-500\\/80:hover {
  background-color: rgb(244 63 94 / 0.8);
}

.hover\\:bg-rose-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50\\/30:hover {
  background-color: rgb(248 250 252 / 0.3);
}

.hover\\:bg-success-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 255 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-100\\/30:hover {
  background-color: rgb(240 255 244 / 0.3);
}

.hover\\:bg-success-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 199 50 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(77 255 121 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-web-bg:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-web-border\\/10:hover {
  background-color: rgb(234 228 217 / 0.1);
}

.hover\\:bg-web-border\\/20:hover {
  background-color: rgb(234 228 217 / 0.2);
}

.hover\\:bg-web-border\\/50:hover {
  background-color: rgb(234 228 217 / 0.5);
}

.hover\\:bg-web-primary\\/90:hover {
  background-color: rgb(209 52 56 / 0.9);
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/25:hover {
  background-color: rgb(255 255 255 / 0.25);
}

.hover\\:bg-white\\/30:hover {
  background-color: rgb(255 255 255 / 0.3);
}

.hover\\:bg-white\\/40:hover {
  background-color: rgb(255 255 255 / 0.4);
}

.hover\\:bg-white\\/50:hover {
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:bg-white\\/60:hover {
  background-color: rgb(255 255 255 / 0.6);
}

.hover\\:bg-yellow-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 249 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-100\\/30:hover {
  background-color: rgb(255 249 219 / 0.3);
}

.hover\\:from-amber-500:hover {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-green-600:hover {
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-700:hover {
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-amber-600:hover {
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}

.hover\\:to-emerald-700:hover {
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}

.hover\\:to-indigo-700:hover {
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}

.hover\\:to-red-50\\/80:hover {
  --tw-gradient-to: rgb(254 242 242 / 0.8) var(--tw-gradient-to-position);
}

.hover\\:to-rose-50\\/80:hover {
  --tw-gradient-to: rgb(255 241 242 / 0.8) var(--tw-gradient-to-position);
}

.hover\\:text-amber-600:hover {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}

.hover\\:text-amber-700:hover {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-800:hover {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-900:hover {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-900:hover {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-400:hover {
  --tw-text-opacity: 1;
  color: rgb(159 131 131 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-50\\/100:hover {
  color: rgb(248 246 246 / 1);
}

.hover\\:text-primary-50\\/30:hover {
  color: rgb(248 246 246 / 0.3);
}

.hover\\:text-primary-600:hover {
  --tw-text-opacity: 1;
  color: rgb(230 33 33 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-700:hover {
  --tw-text-opacity: 1;
  color: rgb(142 16 16 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-900:hover {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-600:hover {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-800:hover {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}

.hover\\:text-secondry-600:hover {
  --tw-text-opacity: 1;
  color: rgb(81 62 62 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-web-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(209 52 56 / var(--tw-text-opacity, 1));
}

.hover\\:text-web-text:hover {
  --tw-text-opacity: 1;
  color: rgb(44 42 41 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:no-underline:hover {
  text-decoration-line: none;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-75:hover {
  opacity: 0.75;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:opacity-85:hover {
  opacity: 0.85;
}

.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-web-primary\\/35:hover {
  --tw-shadow-color: rgb(209 52 56 / 0.35);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-web-primary\\/40:hover {
  --tw-shadow-color: rgb(209 52 56 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-web-primary\\/45:hover {
  --tw-shadow-color: rgb(209 52 56 / 0.45);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-web-primary\\/50:hover {
  --tw-shadow-color: rgb(209 52 56 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:ring-1:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-orange-300:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity, 1));
}

.hover\\:ring-primary-400:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(159 131 131 / var(--tw-ring-opacity, 1));
}

.hover\\:ring-primary-600:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(230 33 33 / var(--tw-ring-opacity, 1));
}

.focus\\:border-amber-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}

.focus\\:border-emerald-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-200:focus {
  --tw-border-opacity: 1;
  border-color: rgb(240 122 122 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(159 131 131 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(124 96 96 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(230 33 33 / var(--tw-border-opacity, 1));
}

.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:border-web-primary:focus {
  --tw-border-opacity: 1;
  border-color: rgb(209 52 56 / var(--tw-border-opacity, 1));
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-amber-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-amber-500\\/20:focus {
  --tw-ring-color: rgb(245 158 11 / 0.2);
}

.focus\\:ring-emerald-500\\/10:focus {
  --tw-ring-color: rgb(16 185 129 / 0.1);
}

.focus\\:ring-primary-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(204 189 189 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(124 96 96 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary-500\\/10:focus {
  --tw-ring-color: rgb(124 96 96 / 0.1);
}

.focus\\:ring-primary-500\\/20:focus {
  --tw-ring-color: rgb(124 96 96 / 0.2);
}

.focus\\:ring-primary-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(230 33 33 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500\\/10:focus {
  --tw-ring-color: rgb(168 85 247 / 0.1);
}

.focus\\:ring-red-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 226 226 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-web-primary\\/20:focus {
  --tw-ring-color: rgb(209 52 56 / 0.2);
}

.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:bg-gray-200:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-20:disabled {
  opacity: 0.2;
}

.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}

.group[open] .group-open\\:-rotate-180 {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:focus-within .group-focus-within\\:text-primary-500 {
  --tw-text-opacity: 1;
  color: rgb(124 96 96 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/hero:hover .group-hover\\/hero\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(242 238 238 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:border-primary-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 232 232 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(230 33 33 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:bg-amber-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-primary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(230 33 33 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-web-primary\\/10 {
  background-color: rgb(209 52 56 / 0.1);
}

.group\\/enlarge:hover .group-hover\\/enlarge\\:text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(230 33 33 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-primary-500 {
  --tw-text-opacity: 1;
  color: rgb(124 96 96 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(230 33 33 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(142 16 16 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-web-primary {
  --tw-text-opacity: 1;
  color: rgb(209 52 56 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group\\/hero:hover .group-hover\\/hero\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-10 {
  opacity: 0.1;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:opacity-20 {
  opacity: 0.2;
}

.group:hover .group-hover\\:opacity-30 {
  opacity: 0.3;
}

.group:hover .group-hover\\:opacity-\\[0\\.06\\] {
  opacity: 0.06;
}

.peer:checked ~ .peer-checked\\:bg-success-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 199 50 / var(--tw-bg-opacity, 1));
}

.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

@media not all and (min-width: 1280px) {

  .max-xl\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .max-xl\\:mb-3 {
    margin-bottom: 0.75rem;
  }
}

@media not all and (min-width: 1024px) {

  .max-lg\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .max-lg\\:mb-3 {
    margin-bottom: 0.75rem;
  }
}

@media not all and (min-width: 768px) {

  .max-md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .max-md\\:mb-\\[30px\\] {
    margin-bottom: 30px;
  }

  .max-md\\:before\\:-top-\\[1px\\]::before {
    content: var(--tw-content);
    top: -1px;
  }

  .max-md\\:after\\:-bottom-\\[1px\\]::after {
    content: var(--tw-content);
    bottom: -1px;
  }
}

@media not all and (min-width: 640px) {

  .max-sm\\:w-full {
    width: 100%;
  }
}

@media (min-width: 340px) {

  .min-\\[340px\\]\\:hidden {
    display: none;
  }
}

@media (max-width: 420px) {

  @media (min-width: 340px) {

    .max-\\[420px\\]\\:min-\\[340px\\]\\:inline {
      display: inline;
    }
  }
}

@media (min-width: 380px) {

  .min-\\[380px\\]\\:inline {
    display: inline;
  }

  .min-\\[380px\\]\\:hidden {
    display: none;
  }
}

@media (min-width: 420px) {

  .min-\\[420px\\]\\:inline {
    display: inline;
  }
}

@media (min-width: 640px) {

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:ml-0 {
    margin-left: 0px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-\\[140px\\] {
    height: 140px;
  }

  .sm\\:h-\\[16px\\] {
    height: 16px;
  }

  .sm\\:h-\\[18px\\] {
    height: 18px;
  }

  .sm\\:h-\\[20px\\] {
    height: 20px;
  }

  .sm\\:h-\\[22px\\] {
    height: 22px;
  }

  .sm\\:h-\\[36px\\] {
    height: 36px;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-80 {
    width: 20rem;
  }

  .sm\\:w-\\[118px\\] {
    width: 118px;
  }

  .sm\\:w-\\[120px\\] {
    width: 120px;
  }

  .sm\\:w-\\[130px\\] {
    width: 130px;
  }

  .sm\\:w-\\[220px\\] {
    width: 220px;
  }

  .sm\\:w-\\[260px\\] {
    width: 260px;
  }

  .sm\\:w-\\[280px\\] {
    width: 280px;
  }

  .sm\\:w-\\[300px\\] {
    width: 300px;
  }

  .sm\\:w-\\[350px\\] {
    width: 350px;
  }

  .sm\\:w-\\[380px\\] {
    width: 380px;
  }

  .sm\\:w-\\[480px\\] {
    width: 480px;
  }

  .sm\\:w-\\[500px\\] {
    width: 500px;
  }

  .sm\\:w-\\[550px\\] {
    width: 550px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-0 {
    min-width: 0px;
  }

  .sm\\:min-w-\\[310px\\] {
    min-width: 310px;
  }

  .sm\\:max-w-\\[100px\\] {
    max-width: 100px;
  }

  .sm\\:max-w-\\[105px\\] {
    max-width: 105px;
  }

  .sm\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:flex-1 {
    flex: 1 1;
  }

  .sm\\:flex-initial {
    flex: 0 1 auto;
  }

  .sm\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .sm\\:self-auto {
    align-self: auto;
  }

  .sm\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .sm\\:border-0 {
    border-width: 0px;
  }

  .sm\\:border-l {
    border-left-width: 1px;
  }

  .sm\\:border-slate-100 {
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:p-3\\.5 {
    padding: 0.875rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .sm\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .sm\\:pt-0 {
    padding-top: 0px;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .sm\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .sm\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .sm\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .sm\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .sm\\:text-\\[21px\\] {
    font-size: 21px;
  }

  .sm\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .sm\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .sm\\:text-\\[9px\\] {
    font-size: 9px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:only\\:col-span-2:only-child {
    grid-column: span 2 / span 2;
  }
}

@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:left-\\[297px\\] {
    left: 297px;
  }

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .md\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-12 {
    margin-top: 3rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-1\\.5 {
    height: 0.375rem;
  }

  .md\\:h-\\[14px\\] {
    height: 14px;
  }

  .md\\:h-\\[18px\\] {
    height: 18px;
  }

  .md\\:h-\\[30px\\] {
    height: 30px;
  }

  .md\\:h-\\[400px\\] {
    height: 400px;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-1\\.5 {
    width: 0.375rem;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-96 {
    width: 24rem;
  }

  .md\\:w-\\[14px\\] {
    width: 14px;
  }

  .md\\:w-\\[18px\\] {
    width: 18px;
  }

  .md\\:w-\\[2px\\] {
    width: 2px;
  }

  .md\\:w-\\[30px\\] {
    width: 30px;
  }

  .md\\:w-\\[35\\%\\] {
    width: 35%;
  }

  .md\\:w-\\[calc\\(100\\%_-_297px\\)\\] {
    width: calc(100% - 297px);
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-max {
    width: max-content;
  }

  .md\\:min-w-\\[220px\\] {
    min-width: 220px;
  }

  .md\\:min-w-\\[260px\\] {
    min-width: 260px;
  }

  .md\\:max-w-\\[290px\\] {
    max-width: 290px;
  }

  .md\\:max-w-\\[297px\\] {
    max-width: 297px;
  }

  .md\\:max-w-md {
    max-width: 28rem;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:gap-16 {
    gap: 4rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .md\\:gap-24 {
    gap: 6rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-x-6 {
    column-gap: 1.5rem;
  }

  .md\\:divide-x > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .md\\:divide-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .md\\:rounded-\\[12px\\] {
    border-radius: 12px;
  }

  .md\\:rounded-\\[16px\\] {
    border-radius: 16px;
  }

  .md\\:rounded-\\[20px\\] {
    border-radius: 20px;
  }

  .md\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:border-slate-100 {
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-12 {
    padding: 3rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-\\[49px\\] {
    padding-top: 49px;
    padding-bottom: 49px;
  }

  .md\\:pb-4 {
    padding-bottom: 1rem;
  }

  .md\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .md\\:pl-2 {
    padding-left: 0.5rem;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:pl-\\[33px\\] {
    padding-left: 33px;
  }

  .md\\:pl-\\[96px\\] {
    padding-left: 96px;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }

  .md\\:pr-8 {
    padding-right: 2rem;
  }

  .md\\:pr-\\[33px\\] {
    padding-right: 33px;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-right {
    text-align: right;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .md\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .md\\:text-\\[17px\\] {
    font-size: 17px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-\\[9px\\] {
    font-size: 9px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .md\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .md\\:after\\:-left-\\[1px\\]::after {
    content: var(--tw-content);
    left: -1px;
  }

  .group:hover .md\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
}

@media (min-width: 1024px) {

  .lg\\:right-0 {
    right: 0px;
  }

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:mb-24 {
    margin-bottom: 6rem;
  }

  .lg\\:mt-20 {
    margin-top: 5rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-9 {
    height: 2.25rem;
  }

  .lg\\:h-\\[42px\\] {
    height: 42px;
  }

  .lg\\:h-\\[44px\\] {
    height: 44px;
  }

  .lg\\:h-\\[48px\\] {
    height: 48px;
  }

  .lg\\:h-\\[500px\\] {
    height: 500px;
  }

  .lg\\:h-\\[82px\\] {
    height: 82px;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:min-h-\\[66px\\] {
    min-height: 66px;
  }

  .lg\\:min-h-\\[82px\\] {
    min-height: 82px;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-7 {
    width: 1.75rem;
  }

  .lg\\:w-9 {
    width: 2.25rem;
  }

  .lg\\:w-\\[105px\\] {
    width: 105px;
  }

  .lg\\:w-\\[115px\\] {
    width: 115px;
  }

  .lg\\:w-\\[120px\\] {
    width: 120px;
  }

  .lg\\:w-\\[297px\\] {
    width: 297px;
  }

  .lg\\:w-\\[300px\\] {
    width: 300px;
  }

  .lg\\:w-\\[340px\\] {
    width: 340px;
  }

  .lg\\:w-\\[360px\\] {
    width: 360px;
  }

  .lg\\:w-\\[calc\\(100\\%\\)\\] {
    width: calc(100%);
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:min-w-0 {
    min-width: 0px;
  }

  .lg\\:min-w-\\[105px\\] {
    min-width: 105px;
  }

  .lg\\:min-w-\\[115px\\] {
    min-width: 115px;
  }

  .lg\\:min-w-\\[120px\\] {
    min-width: 120px;
  }

  .lg\\:min-w-\\[121px\\] {
    min-width: 121px;
  }

  .lg\\:min-w-\\[210px\\] {
    min-width: 210px;
  }

  .lg\\:min-w-\\[250px\\] {
    min-width: 250px;
  }

  .lg\\:min-w-\\[300px\\] {
    min-width: 300px;
  }

  .lg\\:max-w-\\[105px\\] {
    max-width: 105px;
  }

  .lg\\:max-w-\\[115px\\] {
    max-width: 115px;
  }

  .lg\\:max-w-\\[120px\\] {
    max-width: 120px;
  }

  .lg\\:max-w-\\[121px\\] {
    max-width: 121px;
  }

  .lg\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .lg\\:max-w-\\[300px\\] {
    max-width: 300px;
  }

  .lg\\:max-w-none {
    max-width: none;
  }

  .lg\\:flex-1 {
    flex: 1 1;
  }

  .lg\\:flex-none {
    flex: none;
  }

  .lg\\:shrink-0 {
    flex-shrink: 0;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .lg\\:gap-20 {
    gap: 5rem;
  }

  .lg\\:gap-24 {
    gap: 6rem;
  }

  .lg\\:gap-3\\.5 {
    gap: 0.875rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:overflow-visible {
    overflow: visible;
  }

  .lg\\:rounded-t-none {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:border-r-0 {
    border-right-width: 0px;
  }

  .lg\\:border-t-0 {
    border-top-width: 0px;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-12 {
    padding: 3rem;
  }

  .lg\\:p-14 {
    padding: 3.5rem;
  }

  .lg\\:p-2\\.5 {
    padding: 0.625rem;
  }

  .lg\\:p-3\\.5 {
    padding: 0.875rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .lg\\:px-\\[12px\\] {
    padding-left: 12px;
    padding-right: 12px;
  }

  .lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .lg\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .lg\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .lg\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:\\[-webkit-mask-image\\:none\\] {
    -webkit-mask-image: none;
  }

  .lg\\:\\[mask-image\\:none\\] {
    mask-image: none;
  }
}

@media (min-width: 1280px) {

  .xl\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .xl\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .xl\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .xl\\:w-\\[180px\\] {
    width: 180px;
  }

  .xl\\:w-\\[332px\\] {
    width: 332px;
  }

  .xl\\:w-\\[460px\\] {
    width: 460px;
  }

  .xl\\:w-\\[480px\\] {
    width: 480px;
  }

  .xl\\:w-\\[calc\\(100\\%_-_180px\\)\\] {
    width: calc(100% - 180px);
  }

  .xl\\:w-\\[calc\\(100\\%_-_480px\\)\\] {
    width: calc(100% - 480px);
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:max-w-\\[300px\\] {
    max-width: 300px;
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:flex-col {
    flex-direction: column;
  }

  .xl\\:border-l {
    border-left-width: 1px;
  }

  .xl\\:border-t-0 {
    border-top-width: 0px;
  }

  .xl\\:px-\\[16px\\] {
    padding-left: 16px;
    padding-right: 16px;
  }

  .xl\\:pl-8 {
    padding-left: 2rem;
  }

  .xl\\:pr-\\[25px\\] {
    padding-right: 25px;
  }

  .xl\\:pt-0 {
    padding-top: 0px;
  }

  .xl\\:text-\\[20px\\] {
    font-size: 20px;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.peer:checked ~ .rtl\\:peer-checked\\:after\\:-translate-x-full:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  appearance: none;
}

.\\[\\&\\:nth-last-child\\(1\\)\\]\\:mb-0:nth-last-child(1) {
  margin-bottom: 0px;
}

.\\[\\&_summary\\:\\:-webkit-details-marker\\]\\:hidden summary::-webkit-details-marker {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,qCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,qCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B,CAA1B;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAC1B;EAAA;AAAgC;AAAhC;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAChC;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,UAA+B;EAA/B;AAA+B;AAA/B;EAAA,QAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,2BAA+B;IAA/B;EAA+B;;EAA/B;IAAA,eAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,0BAA+B;IAA/B;EAA+B;;EAA/B;IAAA,0BAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,mBAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yBAA+B;UAA/B;AAA+B;AAA/B;EAAA,wBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,0DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,8FAA+B;EAA/B;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B,mDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B,mDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B,mDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+CAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+CAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,qDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,6CAA+B;EAA/B,2DAA+B;EAA/B;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,gFAA+B;EAA/B,oGAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,0DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,wJAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;;AAK/B,oFAAoF;AACpF;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2EAA2E;EAC3E,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,MAAM;EACN,wCAAwC;EACxC,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;;;;;EAQE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EAId,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AAPd;;AAUA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;;;;;;EASE,6BAA6B;EAC7B,gCAAgC;EAEhC,4CAA4C;EAC5C,yDAAiD;EAAjD,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAEhB,eAAe;EACf,aAAa;EACb,gBAAgB;EAEhB,yDAAuD;EACvD,4BAA4B;EAC5B,0BAA0B;EAC1B,qCAAqC;EACrC,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,yDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;AACzB;;AAYA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,QAAQ;EACR,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yDAAyD;EACzD,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;;EAEE;;IAEE,0BAA0B;IAC1B,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAvjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,gBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,wBAwjBA;EAxjBA,wDAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,gBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,2BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,4DAwjBA;EAxjBA,oEAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,4DAwjBA;EAxjBA,mEAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,4DAwjBA;EAxjBA,oEAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,gDAwjBA;EAxjBA,6DAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,+EAwjBA;EAxjBA,mGAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,6EAwjBA;EAxjBA,iGAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0CAwjBA;EAxjBA,uDAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,gFAwjBA;EAxjBA,oGAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,wCAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,uCAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,wCAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,uCAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,2GAwjBA;EAxjBA,yGAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,8BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,2GAwjBA;EAxjBA,yGAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,2GAwjBA;EAxjBA,yGAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,iBAwjBA;EAxjBA,iBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,yBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,qBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,mBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,iBAwjBA;EAxjBA,iBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,oBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA,kBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,sBAwjBA;EAxjBA;AAwjBA;;AAxjBA;;EAAA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,0BAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,0BAwjBA;IAxjBA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;;IAAA;MAAA;IAwjBA;EAAA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,wBAwjBA;IAxjBA,0DAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,wBAwjBA;IAxjBA,kEAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,sBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,oBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,eAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,gBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,wBAwjBA;IAxjBA,0DAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,wBAwjBA;IAxjBA,kEAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,sBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,oBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,sBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,oBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,oBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,eAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,eAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,sBAwjBA;IAxjBA,8BAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,0BAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,2BAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,qBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,oBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,iBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,eAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,eAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,mBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA,kBAwjBA;IAxjBA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;;EAxjBA;IAAA;EAwjBA;AAAA;;AAxjBA;;EAAA;IAAA;EAwjBA;AAAA;;AAxjBA;EAAA,0BAwjBA;EAxjBA,uBAwjBA;EAxjBA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA;;AAxjBA;EAAA;AAwjBA","sourcesContent":["@import \"tailwindcss/base\";\n@import \"tailwindcss/components\";\n@import \"tailwindcss/utilities\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url('https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=Outfit:wght@100..900&display=swap');\n\n/* Hide native video controls, especially the iOS Safari large play button overlay */\nvideo::-webkit-media-controls {\n  display: none !important;\n}\nvideo::-webkit-media-controls-start-playback-button {\n  display: none !important;\n}\nvideo::-webkit-media-controls-enclosure {\n  display: none !important;\n}\nvideo::-webkit-media-controls-overlay-play-button {\n  display: none !important;\n}\n\nbody {\n  font-size: 14px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n}\n\n.container {\n  margin: 0 auto;\n}\n\ntable {\n  width: 100%;\n}\n\ntd {\n  padding: 4px 0;\n  text-align: left;\n  font-weight: 400;\n  font-size: 16px;\n  color: #513e3e;\n}\n\n.billing-table td:nth-child(2) {\n  color: #281f1f;\n  text-align: right;\n}\n\nth {\n  padding: 8px 0;\n  text-align: left;\n  font-weight: 500;\n  font-size: 16px;\n  color: #281f1f;\n  border-top: 1px solid #ccbdbd;\n}\n\nth:nth-child(2) {\n  padding: 4px 0;\n  text-align: right;\n}\n\n.cus-checkbox {\n  display: block;\n  position: relative;\n}\n\n.cus-checkbox input {\n  padding: 0;\n  height: 100%;\n  width: 100%;\n  margin-bottom: 0;\n  display: none;\n  cursor: pointer;\n  position: absolute;\n}\n\n.cus-checkbox label {\n  position: relative;\n  cursor: pointer;\n}\n\n.cus-checkbox span {\n  height: 24px;\n  width: 24px;\n  flex: 0 0 24px;\n  display: block;\n  border: 1px solid #f07a7a;\n  border-radius: 4px;\n  background-color: #fce8e8;\n  position: relative;\n  cursor: pointer;\n  transition: all 250ms ease-in-out;\n}\n\nhtml,\nbody {\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n.cus-checkbox input:checked+span {\n  background-color: #e62121;\n  border-color: #e62121;\n}\n\n.cus-checkbox span:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 2px;\n  left: 9px;\n  width: 6px;\n  height: 14px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n  opacity: 0;\n  transition: all 250ms ease-in-out;\n}\n\n.cus-checkbox input:checked+span:after {\n  opacity: 1;\n}\n\n.cus-radio span {\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #f07a7a;\n  border-radius: 24px;\n  background-color: #fce8e8;\n  position: relative;\n  cursor: pointer;\n  transition: all 250ms ease-in-out;\n}\n\n.cus-radio span:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  background: #fff;\n  width: 16px;\n  height: 16px;\n  border-radius: 20px;\n  opacity: 0;\n  transition: all 250ms ease-in-out;\n}\n\n.cus-radio input:checked+span {\n  background-color: #e62121;\n  border-color: #e62121;\n}\n\n.cus-radio input:checked+span:after {\n  opacity: 1;\n}\n\n/* Tooltip container */\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n/* Tooltip text */\n.tooltip-text {\n  visibility: hidden;\n  width: 120px;\n  background-color: rgba(0, 0, 0, 0.75);\n  color: #fff;\n  text-align: center;\n  border-radius: 4px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  /* Position above the element */\n  left: 50%;\n  margin-left: -60px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n/* Tooltip arrow */\n.tooltip-text::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: black transparent transparent transparent;\n}\n\n/* Show the tooltip text when hovering */\n.tooltip-container:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n}\n\n.admin-table {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  position: relative;\n  /* Ensures the sticky elements are within the correct positioning context */\n  /* max-height: 600px;  */\n}\n\n.admin-table th {\n  padding: 8px 16px;\n  color: #281f1f;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #ccc;\n  background: #f2eeee;\n  text-align: left;\n  white-space: nowrap;\n  position: sticky;\n  /* Sticky headers */\n  top: 0;\n  /* Ensures the header stays at the top */\n  z-index: 1;\n  /* Ensures headers are above rows */\n}\n\n.admin-table td {\n  padding: 8px 16px;\n  color: #513e3e;\n  font-size: 16px;\n  font-weight: 400;\n  border: 1px solid #ccc;\n  background: #f8f6f6;\n}\n\n.admin-table tr th:nth-child(1),\n.admin-table tr td:nth-child(1) {\n  border-left: none;\n}\n\n.admin-table tr th:nth-last-child(1),\n.admin-table tr td:nth-last-child(1) {\n  border-right: none;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.medicine-table table {\n  border: none;\n}\n\n.medicine-table table th {\n  color: #9f8383;\n  font-size: 16px;\n  font-weight: normal;\n}\n\n.medicine-table table th,\n.medicine-table table td {\n  padding: 8px 5px;\n  text-align: left;\n  border: none;\n}\n\n.medicine-table table th:nth-child(1),\n.medicine-table table th:nth-child(2),\n.medicine-table table th:nth-child(3),\n.medicine-table table th:nth-child(4),\n.medicine-table table td:nth-child(1),\n.medicine-table table td:nth-child(2),\n.medicine-table table td:nth-child(3),\n.medicine-table table td:nth-child(4) {\n  width: 60px;\n}\n\n.loader {\n  display: flex;\n  column-gap: 5px;\n  margin: 0 auto 12px;\n  justify-content: center;\n}\n\n.loader .load-circle {\n  width: 8px;\n  height: 8px;\n  background-color: black;\n  border-radius: 50%;\n  animation: loading 500ms infinite alternate;\n}\n\n.loader .load-circle:nth-child(1) {\n  animation-delay: -250ms;\n}\n\n.loader .load-circle:nth-child(2) {\n  animation-delay: -500ms;\n}\n\n.loader .load-circle:nth-child(3) {\n  animation-delay: -750ms;\n}\n\n@keyframes loading {\n  0% {\n    transform: translateY(-8px);\n  }\n\n  100% {\n    transform: translateY(5px);\n  }\n}\n\n.health-loader {\n  color: #1e1e1e;\n}\n\n.health-loader {\n  color: currentColor;\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.health-loader div {\n  transform-origin: 40px 40px;\n  animation: WheelLoader 1.4s linear infinite;\n}\n\n.health-loader div:after {\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 10px;\n  left: 36.8px;\n  width: 6px;\n  height: 18px;\n  border-radius: 20px;\n  background: #1e1e1e;\n}\n\n.health-loader div:nth-child(1) {\n  transform: rotate(0deg);\n  animation-delay: -1.6s;\n}\n\n.health-loader div:nth-child(2) {\n  transform: rotate(46deg);\n  animation-delay: -1.4s;\n}\n\n.health-loader div:nth-child(3) {\n  transform: rotate(92deg);\n  animation-delay: -1.2s;\n}\n\n.health-loader div:nth-child(4) {\n  transform: rotate(138deg);\n  animation-delay: -1s;\n}\n\n.health-loader div:nth-child(5) {\n  transform: rotate(184deg);\n  animation-delay: -0.8s;\n}\n\n.health-loader div:nth-child(6) {\n  transform: rotate(230deg);\n  animation-delay: -0.6s;\n}\n\n.health-loader div:nth-child(7) {\n  transform: rotate(270deg);\n  animation-delay: -0.4s;\n}\n\n.health-loader div:nth-child(8) {\n  transform: rotate(320deg);\n  animation-delay: -0.4s;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  border: 1px solid transparent;\n  -webkit-text-fill-color: #281f1f;\n  -webkit-box-shadow: 0 0 0px 1000px transparent inset;\n  box-shadow: 0 0 0px 1000px transparent inset;\n  transition: background-color 5000s ease-in-out 0s;\n  color: #281f1f;\n}\n\nselect {\n  appearance: none;\n  width: 100%;\n  cursor: pointer;\n  outline: none;\n  box-shadow: none;\n  padding-right: 20px;\n  background-image: url(\"../public/icons/arrow-down.svg\");\n  background-repeat: no-repeat;\n  background-size: 28px 28px;\n  background-position: center right 5px;\n  width: 100%;\n  padding-right: 40px !important;\n}\n\nselect:focus {\n  background-image: url(\"../public/icons/arrow-up.svg\");\n}\n\n.react-date-picker__wrapper {\n  border: none !important;\n}\n\n.react-date-picker__wrapper input {\n  outline: none !important;\n  background: transparent !important;\n  border: none !important;\n}\n\n@-webkit-keyframes WheelLoader {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes WheelLoader {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.react-datepicker-popper {\n  right: 0;\n  left: auto !important;\n  transform: translate(0px, 56px) !important;\n}\n\n.react-date-picker__button:enabled:hover .react-date-picker__button__icon,\n.react-date-picker__button:enabled:focus .react-date-picker__button__icon {\n  stroke: #b2a2a2 !important;\n}\n\n/* Large checkbox (80px) checkmark centering */\n.cus-checkbox span[style*=\"height: '80px'\"]::after {\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) rotate(45deg) !important;\n  width: 12px !important;\n  height: 24px !important;\n  border-width: 0 3px 3px 0 !important;\n}\n\n@keyframes gradient-xy {\n\n  0%,\n  100% {\n    background-size: 400% 400%;\n    background-position: left center;\n  }\n\n  50% {\n    background-size: 200% 200%;\n    background-position: right center;\n  }\n}\n\n.animate-gradient-xy {\n  animation: gradient-xy 3s ease infinite;\n}\n\n.thin-scrollbar::-webkit-scrollbar {\n  width: 4px;\n}\n\n.thin-scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.thin-scrollbar::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 10px;\n}\n\n.thin-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n/* Robust single-container infinite marquee animations */\n.animate-marquee-infinite {\n  animation: marquee-infinite 100s linear infinite;\n}\n\n.animate-marquee-infinite-fast {\n  animation: marquee-infinite 85s linear infinite;\n}\n\n.animate-marquee-infinite-reverse {\n  animation: marquee-infinite-reverse 100s linear infinite;\n}\n\n@keyframes marquee-infinite {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n@keyframes marquee-infinite-reverse {\n  0% {\n    transform: translateX(-50%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n@keyframes logo-zoom-pulse {\n  0%, 100% {\n    transform: scale(0.9);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.animate-logo-zoom {\n  animation: logo-zoom-pulse 2s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
